import * as React from 'react';
import { Link, useParams } from 'react-router-dom';
import {
  VStack,
  Heading,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Button,
  Divider,
  SimpleGrid,
} from '@chakra-ui/react';

import { Fetch } from 'utils/fetch';
import { Layout } from 'views/components/layout';
import { InlineEditor } from 'views/components/inline_editor';
import { Show as Response } from 'interfaces/api/checks/show';

export const Show = () => {
  const { id } = useParams<Record<string, string | undefined>>()
  const [response, setResponse] = React.useState<Response | undefined>(undefined);
  const [loading, setLoading] = React.useState<boolean>(true);

  React.useEffect(() => {
    Fetch.get(`checks/${id}`).then(res => {
      setLoading(false);

      if (res?.error) {
        return false;
      }

      setResponse(res);
    });
  }, [id]);

  return (
    <Layout
      currentNavi='checks'
      loading={loading}
      name={response?.my?.name}
      avatar={response?.my?.avatar}
    >
      <VStack
        w='full'
        h='full'
      >
        <Card
          w='full'
          h='full'
        >
          <CardHeader>
            <Heading size='md'>{response?.check?.title ? response.check.title : 'チェックシート項目詳細'}</Heading>
            <Divider mt={3} />
          </CardHeader>
          <CardBody>
            {response &&
              <>
                <InlineEditor
                  name='id'
                  value={response.check.id}
                  title='ID'
                  isReadOnly={true}
                />

                <InlineEditor
                  name='title'
                  value={response.check.title}
                  title='タイトル'
                  isRequired={true}
                  url={`checks/${id}`}
                />

                <InlineEditor
                  name='content'
                  value={response?.check?.content}
                  title='内容'
                  isRequired={true}
                  url={`checks/${id}`}
                  type='textarea'
                />
              </>
            }
          </CardBody>

          <CardFooter>
            <Button
              w='full'
              as={Link}
              to='/checks'
            >
              一覧へ
            </Button>
          </CardFooter>
        </Card>

      </VStack>
    </Layout>
  );
};
